import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3.99583 2.77077C3.99583 1.83649 4.75322 1.0791 5.6875 1.0791H8.89583C9.03507 1.0791 9.16861 1.13441 9.26707 1.23287L12.1837 4.14954C12.2822 4.24799 12.3375 4.38153 12.3375 4.52077V9.4791C12.3375 10.4134 11.5801 11.1708 10.6458 11.1708H10.5875V11.2291C10.5875 12.1634 9.83012 12.9208 8.89583 12.9208H3.9375C3.00322 12.9208 2.24583 12.1634 2.24583 11.2291V4.52077C2.24583 3.58649 3.00322 2.8291 3.9375 2.8291H3.99583V2.77077ZM3.99583 3.8791H3.9375C3.58312 3.8791 3.29583 4.16639 3.29583 4.52077V11.2291C3.29583 11.5835 3.58312 11.8708 3.9375 11.8708H8.89583C9.25022 11.8708 9.5375 11.5835 9.5375 11.2291V11.1708H5.6875C4.75322 11.1708 3.99583 10.4134 3.99583 9.4791V3.8791ZM5.6875 10.1208C5.33312 10.1208 5.04583 9.83348 5.04583 9.4791V2.77077C5.04583 2.41639 5.33312 2.1291 5.6875 2.1291H8.37083V3.3541C8.37083 4.28838 9.12822 5.04577 10.0625 5.04577H11.2875V9.4791C11.2875 9.83348 11.0002 10.1208 10.6458 10.1208H5.6875ZM10.545 3.99577H10.0625C9.70812 3.99577 9.42084 3.70848 9.42084 3.3541V2.87156L10.545 3.99577Z",
      fill: "inherit"
    }, null, -1)
  ])))
}
export default { render: render }